import React from "react";
import FormInput from "../../../../components/FormInput";
import Button from "../../../../components/Button";
import styles from "../css/stockTransfer.module.css";

export default function StockTransferNonDrugView({ variant, selectedRow, isApproved, onAddToInventory }) {
  if (!selectedRow) return null;

  // Helper: format yyyy-mm-dd to dd/mm/yyyy for UI display only
  const formatDateDMY = (yyyyMmDd) => {
    const s = String(yyyyMmDd || '').trim();
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!m) return s;
    return `${m[3]}/${m[2]}/${m[1]}`;
  };

  const isClinic = variant === "clinic";

  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label={isClinic ? "Items  Name" : "Product Name"}
            type="text"
            name={isClinic ? "clinicProductName" : "productName"}
            value={selectedRow?.drugName || ""}
            readOnly
          />
        </div>
        <div className={styles.field}>
          <FormInput
            label="Branch"
            type="text"
            name="branch"
            value={selectedRow?.transferTo || ""}
            readOnly
          />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label="SKU"
            type="text"
            name="sku"
            value={selectedRow?.sku || ""}
            onChange={() => {}}
          />
        </div>
        <div className={styles.field}>
          {isClinic ? (
            <FormInput
              label="Bar code"
              type="text"
              name="barcode"
              value={selectedRow?.barcode || ""}
              onChange={() => {}}
            />
          ) : (
            <FormInput
              label="Category"
              type="text"
              name="category"
              value={selectedRow?.itemCategory || ""}
              readOnly
            />
          )}
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label="Pack Size"
            type="text"
            name="packSize"
            value={selectedRow?.packSize || ""}
            onChange={() => {}}
          />
        </div>
        <div className={styles.field}>
          <FormInput
            label="Cost"
            type="text"
            name="cost"
            value={selectedRow?.costPrice != null ? selectedRow.costPrice.toString() : ""}
            onChange={() => {}}
          />
        </div>
        <div className={styles.field}>
          <FormInput
            label="Expiry Date"
            type="text"
            name="expiryDate"
            value={formatDateDMY(selectedRow?.expiryDate || "")}
            readOnly
          />
        </div>
      </div>

      <hr className={styles.divider} />

      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label="Date Requested"
            type="text"
            name="dateRequested"
            value={formatDateDMY(selectedRow?.requestDate || "")}
            onChange={() => {}}
          />
        </div>
        <div className={styles.field}>
          <FormInput
            label="Requested By"
            type="text"
            name="requestedBy"
            value={selectedRow?.requestedByName || ""}
            onChange={() => {}}
          />
        </div>
      </div>

      <div className={styles.row}>
        <div className={styles.field}>
          <FormInput
            label="Note"
            type="text"
            name="note"
            value={selectedRow?.note || ""}
            onChange={() => {}}
          />
        </div>
      </div>

      <div className={styles.quantityRow}>
        <div className={styles.field}>
          <FormInput
            label="Quantity"
            type="text"
            name="quantity"
            value={selectedRow?.requestedQty?.toString?.() || ""}
            onChange={() => {}}
            className={styles.quantityNarrow}
          />
        </div>
        {isApproved && (
          <Button variant="primary" onClick={onAddToInventory} className={styles.addInventoryBtn}>
            Add to Inventory
          </Button>
        )}
      </div>
    </div>
  );
}
